"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var semantic_ui_react_1 = require("semantic-ui-react");
var react_intersection_observer_1 = require("react-intersection-observer");
var index_module_scss_1 = __importDefault(require("../../index.module.scss"));
var i18next_1 = require("i18next");
function CollectionsSection() {
    var _a;
    var _b = (0, react_intersection_observer_1.useInView)({
        rootMargin: "0px 0px",
    }), ref = _b.ref, inView = _b.inView;
    var list = (0, i18next_1.t)("collectiblePrivate.list");
    return ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: index_module_scss_1.default.items }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: index_module_scss_1.default.container, ref: ref, style: inView
                    ? {
                        transform: "scale(1)",
                        filter: "grayscale(0)",
                        transition: "ease-in-out 0.5s",
                    }
                    : {
                        transform: "scale(0.8)",
                        filter: "grayscale(1)",
                        opacity: "0.5",
                        transition: "ease-in-out 0.8s",
                    } }, { children: [(0, jsx_runtime_1.jsx)("h3", { dangerouslySetInnerHTML: {
                            __html: (0, i18next_1.t)("collectiblePrivate.contentTitle"),
                        } }), (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Grid, __assign({ columns: "three", divided: true }, { children: (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Grid.Row, { children: (_a = Object.keys(list)) === null || _a === void 0 ? void 0 : _a.map(function (key, index) {
                                var element = list[key];
                                return ((0, jsx_runtime_1.jsx)(semantic_ui_react_1.Grid.Column, __assign({ className: index_module_scss_1.default.column }, { children: (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Card, __assign({ className: index_module_scss_1.default.benefit }, { children: (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Card.Content, __assign({ className: index_module_scss_1.default.content }, { children: (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Card.Header, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: index_module_scss_1.default.collection_profile }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: index_module_scss_1.default.benefits_details }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: index_module_scss_1.default.image_container }, { children: (0, jsx_runtime_1.jsx)("img", { src: element.bg }) })), (0, jsx_runtime_1.jsx)("p", { className: index_module_scss_1.default.details, dangerouslySetInnerHTML: { __html: element.name } }), (0, jsx_runtime_1.jsx)("br", {})] })) })) }) })) })) }), index));
                            }) }) }))] })) })) }));
}
exports.default = CollectionsSection;
